import { CoachAvailabilityScreen } from '@/components/CoachAvailabilityScreen';

export default function CoachAvailability() {
  return <CoachAvailabilityScreen />;
}
